import { Dropdown, DropdownMenu, DropdownTrigger } from '@app/components/various/Dropdown';
import { AddCircleOutline } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContentBlockContext } from '../context/ContentBlockContext';

interface Props {
  isVisible?: boolean;
}

export const AddContentPart = ({ isVisible = false }: Props) => {
  const { t } = useTranslation(['cms']);
  const { addButtonPart, addTextPart, setIsAddPartPopupVisible } = React.useContext(ContentBlockContext);

  return (
    <Dropdown
      title={t('cms:add_content_part')}
      onOpen={() => setIsAddPartPopupVisible(true)}
      onClose={() => setIsAddPartPopupVisible(false)}
    >
      <DropdownTrigger>
        <button
          type="button"
          aria-label={t('cms:add_content_part')}
          className={cn('invisible absolute bottom-0 right-1/2 size-6 translate-x-1/2 translate-y-1/2 rounded-full', {
            visible: isVisible,
          })}
        >
          <AddCircleOutline className="rounded-full bg-cmsPink-20 text-white" />
        </button>
      </DropdownTrigger>
      <DropdownMenu
        items={[
          {
            key: 'text',
            label: t('cms:text_part'),
            onClick: addTextPart,
          },
          {
            key: 'button',
            label: t('cms:button'),
            onClick: addButtonPart,
          },
        ]}
      />
    </Dropdown>
  );
};
